import { ExecutionResult } from '@lcs/shared/api';
import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { CallCostDetailView } from '../../call-cost-details/models/call-cost-detail-view.model';
import { ProviderCallCostSaveModel } from '../models/add-provider-call-costs-data';

export const addProviderCallCost = createAction('[Add ProviderCallCost] Add ProviderCallCost');

export const createProviderCallCostPreview = createAction(
   '[Create ProviderCallCost] Create ProviderCallCostPreview',
   props<{ providerCallCost: ProviderCallCostSaveModel }>()
);

export const createProviderCallCost = createAction(
   '[Create ProviderCallCost] Create ProviderCallCost',
   props<{
      providerCallCostPreview: ExecutionResult<CallCostDetailView[]>;
      providerCallCost: ProviderCallCostSaveModel;
   }>()
);

export const createProviderCallCostUpload = createAction(
   '[Create ProviderCallCost] Create ProviderCallCostUpload',
   props<{
      providerCallCostPreview: ExecutionResult<CallCostDetailView[]>;
      providerCallCost: ProviderCallCostSaveModel;
   }>()
);

export const createProviderCallCostSuccess = createAction(
   '[Create ProviderCallCost] Create ProviderCallCostSuccess',
   props<{ providerCallCostId: number }>()
);

export const createProviderCallCostFailure = createAction(
   '[API] Create ProviderCallCost Failure',
   props<SingleGraphError>()
);
